import { BaoxianProdunctInfoComponent } from './../components/baoxian-produnct-info/baoxian-produnct-info';
import { BusscanActivationComponent } from './../components/busscan-activation/busscan-activation';

import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { NativeService } from "../providers/NativeService";
import { HttpService } from "../providers/HttpService";
import { Utils } from "../providers/Utils";
import { GlobalData } from "../providers/GlobalData";
import { Logger } from "../providers/Logger";
import { SearchModel, PassengerContainer } from '../models/SearchModel';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicStorageModule } from '@ionic/storage';
import { AppVersion } from '@ionic-native/app-version';
import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { CalendarModule } from "ion2-calendar";
import { Contacts } from '@ionic-native/contacts';
import { ThemeableBrowser } from '@ionic-native/themeable-browser';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { SchFilterComponent } from '../components/sch-filter/sch-filter';
import { Keyboard } from '@ionic-native/keyboard';
import { FileOpener } from '@ionic-native/file-opener';
import * as ionicGalleryModal from 'ionic-gallery-modal';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
//import {GaoDeMapComponent} from '../components/gao-de-map/gao-de-map';
// import { QRCodeModule } from 'angular2-qrcode';
 import { Alipay } from '@ionic-native/alipay'; 

@NgModule({

  declarations: [
    MyApp,
    SchFilterComponent,
    BaoxianProdunctInfoComponent,
    BusscanActivationComponent,
    //SortByPipe//,GaoDeMapComponent
  ],

  imports: [
    ionicGalleryModal.GalleryModalModule,
    IonicImageViewerModule,
    CalendarModule,
    BrowserModule,
    HttpModule,
    IonicStorageModule.forRoot(),
    FormsModule, ReactiveFormsModule,
    IonicModule.forRoot(MyApp, {
      mode: 'ios',
      swipeBackEnabled: false,
      tabsHideOnSubPages: 'true',
      backButtonText: '返回',
      iconMode: 'ios',
      pageTransition: 'ios-transition'
    }
    )
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    SchFilterComponent,
    BaoxianProdunctInfoComponent,
    BusscanActivationComponent,
    MyApp//,GaoDeMapComponent
  ],
  providers: [
    AppVersion, File, FileTransfer,
    SearchModel, PassengerContainer,
    StatusBar,
    Keyboard,
    FileOpener,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    NativeService,
    HttpService,
    Utils,
    GlobalData,
    Logger,
    Contacts,
    ThemeableBrowser,  
     Alipay, 
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: ionicGalleryModal.GalleryModalHammerConfig,
    },
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts